export default __webpack_public_path__ + "static/media/bateriatop.b2f0f9ab.png";